<section class="">
  <div class="scan-form-container">
    @if (!showContainer) {
    <div class="scan-form-container__title">{{title}}</div>
    } @if (!showContainer) {
    <div class="scan-form-container__subtitle">{{subtitle}}</div>
    }
    <form [formGroup]="barcodeForm" (ngSubmit)="onSubmit()" class="scan-form" autocomplete="off">
      <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
      <mat-form-field appearance="outline">
        <mat-label style="font-size: 13px">{{placeholder}}</mat-label>
        <input class="barcode" #focusInput matInput formControlName="barcode" />
      </mat-form-field>
      <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
      <button
        mat-button
        mat-stroked-button
        color="#4516B7"
        [ngClass]="buttonChangeColor === 'blue' ? 'successPopup' : 'scan-btn'"
        type="submit">
        <ng-container class="button-title"> OK </ng-container>
        @if (submitting) {
        <mat-spinner [diameter]="10" class="barcode-spinner"></mat-spinner>
        }
      </button>
    </form>
  </div>
</section>
